import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export const WeightIcon = ({
  color = RoutalPalette.grey1,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) => {
  return (
    <SvgIcon {...props} viewBox="0 0 17.5 17.68" style={{ width: `16px`, height: `16px`, color, ...props.style }}>
      <g>
        <path d="M17.02,16.22l-2.66-9.96c-.12-.45-.53-.76-.99-.76h-2.36c.53-.56.86-1.32.86-2.15,0-1.74-1.42-3.15-3.15-3.15s-3.15,1.41-3.15,3.15c0,.83.33,1.59.86,2.15h-2.53c-.47,0-.88.32-1,.78L.42,16.24c-.08.31,0,.63.19.88.2.25.49.39.81.39h14.62c.32,0,.62-.15.81-.4.2-.25.26-.58.18-.89ZM6.57,3.35c0-1.19.97-2.15,2.15-2.15s2.15.97,2.15,2.15-.97,2.15-2.15,2.15-2.15-.97-2.15-2.15ZM16.03,16.51l-14.65-.03L3.9,6.5l9.5.02,2.65,9.98s-.02.01-.02.01Z" />
      </g>
    </SvgIcon>
  );
};
